import { useEffect } from 'react'
import { useLoaderData, Link } from 'react-router'
import { createClient } from '@/api-client'
import { Subscriptions } from '@/api-client/Subscriptions'
import { EstimatedDelivery } from '~/components/subscription/branch-checkout/estimated-delivery'
import logo from './images/logo.svg'
import howto from './images/howto.jpg'
import instagram from './images/instagram.svg'

export const loader = () => {
  return fetchSubscriptions()
}

function fetchSubscriptions() {
  return createClient(Subscriptions).getSubscriptions({ category: 'lossless_bouquet' })
}

export const SubscriptionBranchSubscribed: React.FC = () => {
  const {
    data: { data: subscriptions },
  } = useLoaderData<typeof loader>()

  useEffect(() => {
    const subscription = subscriptions[0]

    if (subscription && subscription.attributes.status === 'active') {
      if (window.fbq) {
        window.fbq(
          'track',
          'Subscribe',
          {
            value: 3200,
            currency: 'JPY',
          },
          {
            eventID: `subscription_subscribed_${subscription.id}`,
          },
        )
      }

      if (window.dataLayer) {
        const key = `subscribed-tracked-${subscription.id}`

        if (!window.localStorage.getItem(key)) {
          window.localStorage.setItem(key, '1')
          window.dataLayer.push({ event: 'subscribed' })
        }
      }
    }
  }, [])

  return (
    <div className="min-h-screen bg-bg font-sans flex flex-col">
      <main className="flex-1 max-w-2xl mx-auto w-full flex flex-col">
        <div className="px-5 pt-10 pb-8 border-b border-gray/40 flex flex-col gap-2">
          <Link to="/">
            <img src={logo} alt="FLOWER" className="h-6 mb-6" />
          </Link>
          <h1 className="text-[22px] font-bold text-black leading-relaxed">
            定期便のお申し込みが
            <br />
            完了しました
          </h1>
          <p className="text-[14px] text-[#828282] leading-relaxed">季節の枝ものをお楽しみに😍</p>
        </div>

        {/* TODO: 初回お届け日を表示 */}
        {/* <div className="px-5 pt-8 pb-7 border-b border-gray/40">
          <p className="text-[13px] text-[#828282] mb-3">初回のお届け</p>
          <p className="text-[28px] font-bold text-black leading-tight mb-2">1/17（土）</p>
          <div className="flex flex-col gap-1">
            <div className="flex gap-1.5 items-center text-[#828282]">
              <CalendarIcon />
              <p className="text-[13px] leading-relaxed tracking-wide">月に2回・土曜日にお届け</p>
            </div>
            <div className="flex gap-1.5 items-center text-[#828282]">
              <BoxIcon />
              <p className="text-[13px] leading-relaxed tracking-wide">クロネコヤマトで配送（対面でのお受け取り）</p>
            </div>
          </div>
        </div> */}

        <div className="px-5 pt-7 pb-8 border-b border-gray/40 flex flex-col gap-3">
          <p className="text-[13px] text-[#828282] leading-relaxed tracking-wide">
            お届けのスキップや住所・カードの変更は
            <br />
            マイページからいつでもできます
          </p>
          <Link
            to="/subscription/branch/mypage"
            className="block w-full py-3.5 bg-black text-white text-[14px] font-bold rounded-full text-center tracking-wide"
          >
            マイページを見る
          </Link>
        </div>

        <div className="px-5 py-7 border-b border-gray/40">
          <Link
            to="/subscription/branch/howto"
            target="_blank"
            className="flex gap-4 items-center bg-white rounded-2xl p-4 shadow-[0px_8px_16px_0px_rgba(197,197,197,0.05)]"
          >
            <div className="w-20 h-20 rounded-xl overflow-hidden shrink-0">
              <img src={howto} alt="枝ものを飾る" className="w-full h-full object-cover" />
            </div>
            <div className="flex-1 flex flex-col gap-1">
              <p className="text-[11px] text-[#828282] tracking-widest">はじめてさん向け</p>
              <p className="text-[14px] font-bold text-black leading-relaxed">枝ものが届いたら？まずやってほしい3つのこと</p>
            </div>
            <svg
              className="shrink-0 text-[#828282]"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 8h10M9 4l4 4-4 4" />
            </svg>
          </Link>
        </div>

        <div className="px-5 pt-7 pb-10 flex flex-col gap-4">
          <p className="text-[13px] text-[#828282] leading-relaxed tracking-wide">
            アプリのお花屋さん「FLOWER（フラワー）」の最新情報は公式Instagramで。平日ほぼ毎日ライブ配信中⚡️お花好きさんはぜひフォローをお願いします！
          </p>
          <div>
            <a
              href="https://www.instagram.com/flowr_is/"
              target="_blank"
              className="inline-flex items-center gap-1.5 px-4 py-2 bg-black text-white text-[13px] font-bold rounded-full"
            >
              <img src={instagram} alt="Instagram" className="w-4 h-4" />
              公式Instagramへ
            </a>
          </div>
        </div>
      </main>
    </div>
  )
}

function CalendarIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="2.5" width="12" height="10.5" rx="1.5" />
      <line x1="1" y1="5.5" x2="13" y2="5.5" />
      <line x1="4.5" y1="1" x2="4.5" y2="4" />
      <line x1="9.5" y1="1" x2="9.5" y2="4" />
    </svg>
  )
}

function BoxIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1.5 4.5l5.5 3 5.5-3" />
      <path d="M7 13V7.5" />
      <path d="M12.5 4.5l-5.5-3-5.5 3v5l5.5 3 5.5-3v-5z" />
    </svg>
  )
}
